module.exports = __webpack_public_path__ + "static/media/cancel-md-dark.4894bb89.svg";